import i18n, { i18nNS } from '../i18n';
import moment from 'moment';
import { selectCompanyCulture, selectDateFormat } from '../store/selectors/auth.selector';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const useDateFormat = () => {
  const { t } = useTranslation(i18nNS.calendar);
  const dateFormat = useSelector(selectDateFormat);
  const companyCulture = useSelector(selectCompanyCulture);
  //creationFormat was added to correctly convert the date in "month day"
  //format sent from the hotel and car screen, otherwise in cases
  //where this parameter is not sent, the same previous behavior is maintained
  const formatDate = (date, format = null, creationFormat = null) => {
    let month;
    let day;
    let year;
    switch (format) {
      case 'LL':
        month = i18n.t('calendar:monthNames.' + moment(date).format('MMMM'));
        day = moment(date).format('D');
        year = moment(date).format('YYYY');
        return companyCulture == 'US'
          ? `${t(dateFormat, { MMM: month, D: day })}, ${year}`
          : `${t(dateFormat, { MMM: month, D: day })} ${year}`;
      default: {
        const momentDate = creationFormat ? moment(date, creationFormat) : moment(date);
        month = i18n.t('calendar:monthNamesShort.' + momentDate.format('MMM'));
        day = momentDate.format('DD');
        return t(dateFormat, { MMM: month, D: day });
      }
    }
  };
  return formatDate;
};
